"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SvgIcon = _interopRequireDefault(require("./SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var StepBack = function StepBack(_ref) {
  var size = _ref.size,
      color = _ref.color;
  return _react["default"].createElement(_SvgIcon["default"], {
    title: "step-back",
    size: size
  }, _react["default"].createElement("path", {
    fill: color,
    d: "M1.15 1.05A.75.75 0 012.2.9l3.33 2.5a.75.75 0 010 1.2L2.2 7.1A.75.75 0 011 6.5v-5c0-.16.05-.32.15-.45zM6.5 1c.28 0 .5.22.5.5v5a.5.5 0 01-1 0v-5c0-.28.22-.5.5-.5zM2.25 2.25A.25.25 0 002 2.5v3a.25.25 0 00.4.2l2-1.5a.25.25 0 000-.4l-2-1.5a.25.25 0 00-.15-.05z",
    transform: "matrix(-1 0 0 1 8 0)"
  }));
};

StepBack.defaultProps = {
  size: 8,
  color: '#444'
};
var _default = StepBack;
exports["default"] = _default;